<div class="inner-margin-top pos-rel">
    <img src="assets/images/about-bg.png" class="about-bgs" />
    <img src="assets/images/sponsor-bg.jpg" />
    <div class="sponsor-name">About Us </div>
</div>

<div class="container about-us-content">
    <h3>Empowering Andhra Pradesh for a Greener Tomorrow</h3>
    <p>
        At Empower Andhra Development, we are on a mission to create a cleaner, greener, and more sustainable Andhra
        Pradesh. Our initiative is built on the foundation of collaboration, where the public and private sectors come
        together to drive meaningful change in environmental conservation, sustainable development, and community
        empowerment.
    </p>
    <h3 class="mt-6">Join Us in Our Journey</h3>
    <p>
        Change begins with collective action. Whether you are an individual, a corporation, or a policymaker, Empower Andhra Development invites you to be a part of this transformation. Let’s work together to create a healthier, more resilient Andhra Pradesh—one step at a time.
    </p>
    <p>
        For partnerships, collaborations, or to learn more about our initiatives, reach out to us today.

    </p>
</div>



<div class="vision-mission">
    <div class="vm-content-set">
        <div class="container">
            <div class="row">
                <div class="col-lg-5 col-md-12">
                    <img src="assets/images/vision-mission-img.png" class="img-fluid" />
                </div>
                <div class="col-lg-7 col-md-12">
                    <div class="vision-mission-txt">
                        <h3>OUR <span>VISION</span></h3>
                        <p>
                            Empower Andhra Development is a mission to create a cleaner,
                            greener, and more sustainable Andhra Pradesh
                        </p>
                        <h3 class="mt-6">OUR <span>MISSION</span></h3>
                        <p>
                            Empower Andhra Development is a mission to create a cleaner,
                            greener, and more sustainable Andhra Pradesh by fostering
                            collaboration between public and private sectors. By identifying
                            community needs and encouraging government bodies and private
                            sponsors to fund impactful initiatives, we bridge the gap to drive
                            meaningful and lasting change.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <img src="assets/images/vision-mission.jpg" class="img-fluid" /> -->
</div>

<div class="ep-footer">
    <div class="container">
        <div class="d-flex jusify-space-between">
            <div class="d-flex flex-column">
                <h3>Help</h3>
                <div style="line-height: 20px">
                    <div>+91 9288227228</div>
                    <div>
                        <a href="mailto:info&#64;empowerandhra.com">info&#64;empowerandhra.com</a>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column follow-us-img">
                <h3>Follow us</h3>
                <div class="d-flex gap-3">
                    <img src="assets/images/icon-whatsapp.png" />
                    <img src="assets/images/icon-facebook.png" />
                    <img src="assets/images/icon-instagram.png" />
                    <img src="assets/images/icon-twitter.png" />
                    <img src="assets/images/icon-youtube.png" />
                </div>
            </div>
        </div>
        <hr />
        <div class="d-flex jusify-space-between">
            <div class="d-flex footer-copyrights">
                <div>2025 © Empower Andhra</div>
                <div><a href="#">Terms of Service</a></div>
                <div><a href="#">Privacy Policy</a></div>
            </div>
            <div>Site last updated on: 12-APR-2025</div>
        </div>
    </div>
</div>